module.exports = __webpack_public_path__ + "static/img/Contact.8f36161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact.png
// module id = QCTk
// module chunks = 1